export default "__VITE_ASSET__U5wezpaV__"